<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>{{ $route.meta.title }}</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-danger">
                        <div class="card-header">Master Campaign Types</div>
                        <div class="card-body overflow-auto">
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">Type</th>
                                        <th scope="col">Validity</th>
                                        <th scope="col">Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in campaign_types">
                                        <td>{{ j.type }}</td>
                                        <td>{{ j.validity }}</td>
                                        <td v-if="j.validity == 'Active'">
                                            <button
                                                class="btn btn-danger fa fa-square"
                                                @click="
                                                    changeCT(j.id, 'Inactive')
                                                "
                                            ></button>
                                        </td>
                                        <td v-else>
                                            <button
                                                class="btn btn-success fa fa-play"
                                                @click="
                                                    changeCT(j.id, 'Active')
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.type ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the campaign type"
                                            v-model="ct"
                                        />
                                        <span
                                            v-if="errors.type"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid type.</span
                                        >
                                    </div>
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            @click="addCT"
                                        >
                                            Add Campaign Type
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="card card-danger">
                        <div class="card-header">Master Campaign Medias</div>
                        <div class="card-body overflow-auto">
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">Media</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Validity</th>
                                        <th scope="col">Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in master_campaign_medias">
                                        <td>{{ j.media }}</td>
                                        <td>{{ j.campaign_type.type }}</td>
                                        <td>{{ j.validity }}</td>
                                        <td v-if="j.validity == 'Active'">
                                            <button
                                                class="btn btn-danger fa fa-square"
                                                @click="
                                                    changeCM(j.id, 'Inactive')
                                                "
                                            ></button>
                                        </td>
                                        <td v-else>
                                            <button
                                                class="btn btn-success fa fa-play"
                                                @click="
                                                    changeCM(j.id, 'Active')
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.media ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the campaign media"
                                            v-model="cm"
                                        />
                                        <span
                                            v-if="errors.media"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid media.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.type_id ? 'has-error' : '',
                                        ]"
                                    >
                                        <v-select
                                            placeholder="Pick the campaign type"
                                            v-model="type_id"
                                            :options="campaign_types"
                                            label="type"
                                            :reduce="
                                                (campaign_types) =>
                                                    campaign_types.id
                                            "
                                        ></v-select>
                                        <span
                                            v-if="errors.type_id"
                                            :class="['badge bg-danger']"
                                            >Please pick a valid type.</span
                                        >
                                    </div>
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            @click="addCM"
                                        >
                                            Add Campaign Type
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="card card-danger">
                        <div class="card-header">Master Campaigns</div>
                        <div class="card-body overflow-auto">
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Campaign Value</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Start Date</th>
                                        <th scope="col">End Date</th>
                                        <th scope="col">Validity</th>
                                        <th scope="col">Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in master_campaigns">
                                        <td>{{ j.name }}</td>
                                        <td>{{ j.campaign_value }}</td>
                                        <td>{{ j.campaign_type.type }}</td>
                                        <td>{{ j.start_date }}</td>
                                        <td>{{ j.end_date }}</td>
                                        <td>{{ j.validity }}</td>
                                        <td v-if="j.validity == 'Active'">
                                            <button
                                                class="btn btn-danger fa fa-square"
                                                @click="
                                                    changeMC(j.id, 'Inactive')
                                                "
                                            ></button>
                                        </td>
                                        <td v-else>
                                            <button
                                                class="btn btn-success fa fa-play"
                                                @click="
                                                    changeMC(j.id, 'Active')
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.name ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the campaign name"
                                            v-model="master_campaign.name"
                                        />
                                        <span
                                            v-if="errors.name"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid name.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.campaign_value
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the campaign value"
                                            v-model="
                                                master_campaign.campaign_value
                                            "
                                        />
                                        <span
                                            v-if="errors.campaign_value"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid value.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.type_id ? 'has-error' : '',
                                        ]"
                                    >
                                        <v-select
                                            placeholder="Pick the campaign type"
                                            v-model="master_campaign.type_id"
                                            :options="campaign_types"
                                            label="type"
                                            :reduce="
                                                (campaign_types) =>
                                                    campaign_types.id
                                            "
                                        ></v-select>
                                        <span
                                            v-if="errors.type_id"
                                            :class="['badge bg-danger']"
                                            >Please pick a valid type.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.start_date
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter the campaign start date"
                                            v-model="master_campaign.start_date"
                                        />
                                        <span
                                            v-if="errors.start_date"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid date.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.end_date ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter the campaign end date"
                                            v-model="master_campaign.end_date"
                                        />
                                        <span
                                            v-if="errors.end_date"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid date.</span
                                        >
                                    </div>
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            @click="addMasterCampaign"
                                        >
                                            Add Master Campaign
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="card card-danger">
                        <div class="card-header">Campaign Media</div>
                        <div class="card-body overflow-auto">
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">Campaign</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Media</th>
                                        <th scope="col">Start Date</th>
                                        <th scope="col">End Date</th>
                                        <th scope="col">Total Budget</th>
                                        <th scope="col">Monthly Budget</th>
                                        <th scope="col">Weekly Budget</th>
                                        <th scope="col">Validity</th>
                                        <th scope="col">Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in campaign_medias">
                                        <td>{{ j.master_campaign.name }}</td>
                                        <td>{{ j.campaign_type.type }}</td>
                                        <td>
                                            {{ j.master_campaign_media.media }}
                                        </td>
                                        <td>{{ j.start_date }}</td>
                                        <td>{{ j.end_date }}</td>
                                        <td>{{ j.total_budget }}</td>
                                        <td>{{ j.monthly_budget }}</td>
                                        <td>{{ j.weekly_budget }}</td>
                                        <td>{{ j.validity }}</td>
                                        <td v-if="j.validity == 'Active'">
                                            <button
                                                class="btn btn-danger fa fa-square"
                                                @click="
                                                    changeCampaignMedia(
                                                        j.id,
                                                        'Inactive'
                                                    )
                                                "
                                            ></button>
                                        </td>
                                        <td v-else>
                                            <button
                                                class="btn btn-success fa fa-play"
                                                @click="
                                                    changeCampaignMedia(
                                                        j.id,
                                                        'Active'
                                                    )
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.name ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the campaign name"
                                            v-model="campaign_media.name"
                                        />
                                        <span
                                            v-if="errors.name"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid name.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.campaign_id
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <v-select
                                            placeholder="Pick the master campaign"
                                            v-model="campaign_media.campaign_id"
                                            :options="master_campaigns"
                                            label="name"
                                            :reduce="
                                                (master_campaigns) =>
                                                    master_campaigns.id
                                            "
                                        ></v-select>
                                        <span
                                            v-if="errors.campaign_id"
                                            :class="['badge bg-danger']"
                                            >Please pick a valid campaign.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.media_id ? 'has-error' : '',
                                        ]"
                                    >
                                        <v-select
                                            placeholder="Pick the campaign media"
                                            v-model="campaign_media.media_id"
                                            :options="master_campaign_medias"
                                            label="media"
                                            :reduce="
                                                (master_campaign_medias) =>
                                                    master_campaign_medias.id
                                            "
                                        ></v-select>
                                        <span
                                            v-if="errors.media_id"
                                            :class="['badge bg-danger']"
                                            >Please pick a valid media.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.start_date
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter the campaign start date"
                                            v-model="campaign_media.start_date"
                                        />
                                        <span
                                            v-if="errors.start_date"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid date.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.end_date ? 'has-error' : '',
                                        ]"
                                    >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter the campaign end date"
                                            v-model="campaign_media.end_date"
                                        />
                                        <span
                                            v-if="errors.end_date"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid date.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.total_budget
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="number"
                                            class="form-control"
                                            placeholder="Enter the total budget"
                                            v-model="
                                                campaign_media.total_budget
                                            "
                                            min="1"
                                        />
                                        <span
                                            v-if="errors.total_budget"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid budget.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.monthly_budget
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="number"
                                            class="form-control"
                                            placeholder="Enter the monthly budget"
                                            v-model="
                                                campaign_media.monthly_budget
                                            "
                                            min="1"
                                        />
                                        <span
                                            v-if="errors.monthly_budget"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid budget.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.weekly_budget
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="number"
                                            class="form-control"
                                            placeholder="Enter the weekly budget"
                                            v-model="
                                                campaign_media.weekly_budget
                                            "
                                            min="1"
                                        />
                                        <span
                                            v-if="errors.weekly_budget"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid budget.</span
                                        >
                                    </div>
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            @click="addCampaignMedia"
                                        >
                                            Add Campaign Media
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getCTS();
        this.getCMS();
        this.getMasterCampaigns();
        this.getCampaignMedias();
    },

    data() {
        return {
            campaign_types: [],
            ct: "",
            errors: [],
            master_campaign_medias: [],
            type_id: "",
            cm: "",
            master_campaign: new Form({
                name: "",
                campaign_value: "",
                type_id: "",
                start_date: "",
                end_date: "",
            }),
            master_campaigns: [],
            campaign_medias: [],
            campaign_media: new Form({
                name: "",
                campaign_id: "",
                type_id: "",
                media_id: "",
                start_date: "",
                end_date: "",
                total_budget: "",
                daily_budget: "",
                monthly_budget: "",
                weekly_budget: "",
            }),
        };
    },

    methods: {
        addCT() {
            axios.post("/api/addCampaignType", { type: this.ct }).then(() => {
                this.getCTS();
            });
        },

        getCTS() {
            axios.post("/api/getCampaignTypes").then((response) => {
                this.campaign_types = response.data;
            });
        },

        changeCT(id, status) {
            axios
                .post("/api/changeCampaignType", { id: id, status: status })
                .then(() => {
                    this.getCTS();
                });
        },

        addCM() {
            axios
                .post("/api/addMasterCampaignMedia", {
                    type_id: this.type_id,
                    media: this.cm,
                })
                .then(() => {
                    this.getCMS();
                });
        },

        getCMS() {
            axios.post("/api/getMasterCampaignMedias").then((response) => {
                this.master_campaign_medias = response.data;
            });
        },

        changeCM(id, status) {
            axios
                .post("/api/changeMasterCampaignMedia", {
                    id: id,
                    status: status,
                })
                .then(() => {
                    this.getCMS();
                });
        },

        addMasterCampaign() {
            this.master_campaign.post("/api/addMasterCampaign").then(() => {
                this.getMasterCampaigns();
            });
        },

        getMasterCampaigns() {
            axios.post("/api/getMasterCampaigns").then((response) => {
                this.master_campaigns = response.data;
            });
        },

        changeMC(id, status) {
            axios
                .post("/api/changeMasterCampaign", { id: id, status: status })
                .then(() => {
                    this.getMasterCampaigns();
                });
        },

        addCampaignMedia() {
            this.campaign_media.type_id = this.master_campaign_medias.find(
                (x) => x.id === this.campaign_media.media_id
            ).type_id;
            this.campaign_media.post("/api/addCampaignMedia").then(() => {
                this.getCampaignMedias();
            });
        },

        getCampaignMedias() {
            axios.post("/api/getAllCampaignMedias").then((response) => {
                this.campaign_medias = response.data;
            });
        },

        changeCampaignMedia(id, status) {
            axios
                .post("/api/changeCampaignMedia", { id: id, status: status })
                .then(() => {
                    this.getCampaignMedias();
                });
        },
    },
};
</script>
